import styled from "styled-components";

export const LabelStyle = styled.label`
  font-size: 16px;
  color: rgba(32, 32, 32, 1);
`;